export const CAPACITY_PER_BUS = 50;
export const ADDITIONAL_FROM_TIME_MINUTES = 30;
